import { render, staticRenderFns } from "./m-addAnswerSNPMB.vue?vue&type=template&id=3f23f10a&"
import script from "./m-addAnswerSNPMB.vue?vue&type=script&lang=js&"
export * from "./m-addAnswerSNPMB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports